import React from 'react';
import { Link } from 'react-router-dom';

import Member from './Member';

const Members = props => {
  const { deleteMember, members } = props.memberInfo;
  const { mode } = props;

  const getMembers = () => {
    return members.map(member => {
      const memberInfo = { deleteMember, member };
      return <Member mode={props.mode} memberInfo={memberInfo} key={member.id} />;
    });
  };
  return (
    <div className="box">
      <div className="box-header with-border">
        <h3 className="box-title">Members</h3>
        {mode === 'edit' && (
          <Link className="cus-btn-primary pull-right" to="/member/create">
            Add Member
          </Link>
        )}
      </div>
      <div className="box-body">
        <table className="table table-bordered table-responsive table-hover">
          <thead>
            <tr>
              <th>Name</th>
              <th>Biography</th>
              <th>Photo</th>
              <th>Created At</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>{getMembers()}</tbody>
        </table>
      </div>
    </div>
  );
};

export default Members;
